import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'removeCharacter',
  standalone:true,
})

export class RemoveCharacterPipe implements PipeTransform {

  transform(value: any): any {
    return value.replace('#65286;', '').replace('#65286;', '').replace('#65286;', '');
  }
}
